import React from "react";  
import ForgotPasswordForm from "../../components/Authentication/ForgotPasswordForm";

const ForgotPassword = () => {
  return (
    <>
      <ForgotPasswordForm />
    </>
  );
};

export default ForgotPassword;
